require("intersection-observer");

import { createApp, ref } from "vue";
import MicroModal from 'micromodal';
import LazyLoad from "vanilla-lazyload";

import Chapters from "@Components/Blocks/Chapters.vue";

window.addEventListener("load", function () {
    import("./Mixins/cookie-consent.js");
    import("./Mixins/animations.js");

    //navigation
    const hamburger = document.querySelector(".hamburger");
    const close = document.querySelector(".close-menu");

    if( hamburger != null ) {
        document.addEventListener("click", function(e) {
            const target = e.target.closest(".hamburger");
            const navWrapper = document.querySelector(".nav-wrapper");
            let isActive = navWrapper.getAttribute("aria-hidden");
            
            if( target ) {
                navWrapper.setAttribute("aria-hidden", "false");
            } else if( e.target.closest(".nav-wrapper") == null ) {
                //Close the menu when screen clicked and not menu
                navWrapper.setAttribute("aria-hidden", "true");
            }
        })
    }

    if( close != null ) {
        document.addEventListener("click", function(e) {
            const target = e.target.closest(".close-menu");
            
            if( target ) {
                document.querySelector(".nav-wrapper").setAttribute("aria-hidden", "true");
            }
        })
    }

    let myLazyLoad = new LazyLoad();
    // After your content has changed...
    myLazyLoad.update();

    // GLIDE
    const glideContainer = document.querySelector('.glide');
    
    if( glideContainer != null ) {
        import("./Mixins/carousel.js");
    }

    const chapterToggle = document.querySelector("[data-toggle-chapter]");
    const chapterMenu = document.querySelector(".chapter-nav");
    const closeChapters = document.querySelector(".close-chapters");
    
    if( chapterToggle != null ) {
        let offset = chapterMenu.offsetWidth + chapterToggle.offsetWidth;

        chapterToggle.addEventListener("click", function(e) {
            if( chapterMenu.classList.contains('open') ) {
                chapterMenu.style.left = "calc( 100% - " + chapterToggle.offsetWidth + "px)";
            } else {
                chapterMenu.style.left = "calc( 100% - " + offset + "px)";
            }

            chapterMenu.classList.toggle("open");
        });
    }

    if( closeChapters != null ) {
        closeChapters.addEventListener("click", function(e) {
            if( chapterMenu.classList.contains('open') ) {
                chapterMenu.style.left = "calc( 100% - " + chapterToggle.offsetWidth + "px)";
            } else {
                chapterMenu.style.left = "calc( 100% - " + offset + "px)";
            }

            chapterMenu.classList.toggle("open");
        });
    }

    MicroModal.init();

    const videos = document.querySelector("[data-js-play]");

    if( videos != null ) {
        import("./Mixins/video.js");
    }

    //Javascript Forms
    const jsForm = document.querySelector("form[data-js-submit]");

    if( jsForm != null ) {
        import("./Mixins/forms.js");
    }
});

createApp({
  compilerOptions: {
    whitespace: "condense",
    inheritAttrs: true,
  },
  components: {
    // Hero,
    Chapters,
    // Pagination,
  },
  setup() {
    const filters = [];
    const openingHoursShowing = false;
    const showNav = ref(false);
    return {
      filters,
      showNav,
      openingHoursShowing,
    };
  },
})
  .mount("#app");
